export default __webpack_public_path__ + "static/media/TRAINING_COGNITIVO_ICONA.6934f2b4.svg";